import React, { useContext, useEffect, useState } from 'react';
import { EngineContext } from '../../contexts/engine-context.js';
import { fireComponentEvent, getEngineComponent, getInstanceUUID, getRoot } from '../bridge-commons.js';
import { usePropsManager } from '../props-manager.js';
export function useForceUpdate() {
    const [, setValue] = useState(0);
    return () => setValue(value => ++value);
}
function createFunctionalBridgeComponent(name, ComponentType, metadata) {
    function FunctionalBridgeComponent(props) {
        const engineContext = useContext(EngineContext);
        const forceUpdate = useForceUpdate();
        // Remove props that we don't want to pass down to be managed;
        // eslint-disable-next-line
        const { uuid, children, ssot, onMount, onUnmount, ...otherProps } = props;
        useEffect(() => {
            const engineComponent = getEngineComponent(props, engineContext);
            const onSSOTPropsChange = () => {
                forceUpdate();
            };
            const ssot = engineComponent.getSSOT();
            const unsubscribeFromProps = ssot.subscribeToProps(onSSOTPropsChange);
            fireComponentEvent(engineComponent, 'onMount');
            return () => {
                const engineComponent = getEngineComponent(props, engineContext);
                unsubscribeFromProps();
                fireComponentEvent(engineComponent, 'onUnmount');
                getRoot(engineContext).discard(uuid, getInstanceUUID(props, engineContext), engineContext.parent);
            };
        }, []);
        const engineComponent = getEngineComponent(props, engineContext);
        const componentProps = usePropsManager({ engineComponent, ...otherProps });
        const engineContextValue = {
            ...engineContext,
            parent: engineComponent,
            parentInstanceUUID: getInstanceUUID(props, engineContext),
        };
        return (React.createElement(EngineContext.Provider, { value: engineContextValue },
            React.createElement(ComponentType, { ...componentProps, uuid: uuid }, children)));
    }
    Object.defineProperty(FunctionalBridgeComponent, 'name', { value: name, writable: false });
    Object.defineProperty(FunctionalBridgeComponent, 'propTypes', { value: metadata?.getPropTypes() ?? ComponentType.propTypes, writable: false });
    return FunctionalBridgeComponent;
}
export { createFunctionalBridgeComponent, };
//# sourceMappingURL=functional-bridge.js.map